import { styled, Typography, ButtonBase, IconButton } from '@mui/material'
import {
  MicRounded as MicIcon,
  MicOffRounded as MicOffIcon,
} from '@mui/icons-material'
import { HallAvatar } from '$common/avatar'
import { ActiveAudioWaves } from '$common/active-audio-waves'
import { useCallStorage } from '$logic/call'
import { useOpenedRoomId } from '$logic/opened-room'
import { CallWappPanel } from '$logic/wapp-panels'
import { openCall as openCallPanel } from '$logic/router'
import { useHall } from '$logic/hall/react-hook'
import { t } from '$i18n'
import { CALL_BAR_HEIGHT } from '$comp/_app/components/chat/components/conf'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const Root = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  width: 100%;
  height: ${CALL_BAR_HEIGHT}px;
  padding: 0 16px;
  overflow: hidden;

  &::before {
    content: '';
    display: block;
    position: absolute;

    height: 100%;
    will-change: transform;
    transition: right 250ms linear;

    right: 0;
    width: 300%;
    background: linear-gradient(
      270deg,
      rgba(102, 102, 102, 1) 0%,
      rgba(128, 128, 128, 1) 40%,
      rgba(58, 184, 20, 1) 60%,
      rgba(40, 195, 40, 1) 100%
    );
  }
`

const GroupInfo = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  z-index: 1;
`

const MuteButton = styled(IconButton)`
  transform: translateX(-8px);

  & > svg {
    color: #fff;
  }
`

interface PropTypes {
  isInRoom?: boolean
}
export function MeetingBar({ isInRoom }: PropTypes) {
  const openedRoomId = useOpenedRoomId()
  const {
    roomId,
    muted,
    hallMeta: { isParticipating, name: currentCallName },
  } = useCallStorage()

  const { entity: hall } = useHall(roomId)
  const name = currentCallName || hall?.name

  const showGroupInfo = !isInRoom || openedRoomId !== roomId

  return (
    <Root
      disableRipple
      disableTouchRipple
      onClick={openCallPanel}
      sx={{
        '&::before': { right: muted ? '0' : '-200%' },
      }}
    >
      <GroupInfo>
        {showGroupInfo ? (
          <HallAvatar size={AvatarSize._2XS} roomId={roomId} />
        ) : (
          <ActiveAudioWaves />
        )}

        <Typography
          variant="subtitle3"
          color={isParticipating ? 'white' : 'semiBlack'}
          noWrap
        >
          {showGroupInfo ? name : t('call.ongoingCalls.meeting')}
        </Typography>
      </GroupInfo>

      <MuteButton
        onClick={e => {
          e.stopPropagation()
          CallWappPanel.setMuted(!muted)
        }}
      >
        {muted ? <MicOffIcon /> : <MicIcon />}
      </MuteButton>
    </Root>
  )
}

MeetingBar.defaultProps = {
  isInRoom: false,
}
